module.exports = __webpack_public_path__ + "img/vertical_7_3_9005.0a0bbbc7.png";